var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgPot2(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "104px",
    viewBox: "0 0 47 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pot1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "68.6694733%",
    y1: "-6.66432423%",
    x2: "68.6694733%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE62BE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB3A8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.15121679,0.0489334015 L21.8487832,0.0489334015 C22.9533527,0.0489334015 23.8487832,0.944363902 23.8487832,2.0489334 C23.8487832,2.09748677 23.8470151,2.14602403 23.8434825,2.19444871 L20.2433946,51.5438463 C20.1671365,52.5891799 19.2968068,53.398331 18.2486953,53.398331 L5.75130468,53.398331 C4.70319319,53.398331 3.83286351,52.5891799 3.75660538,51.5438463 L0.156517487,2.19444871 C0.0761516012,1.09280671 0.904059474,0.134599988 2.00570148,0.0542341021 C2.05412616,0.0507014732 2.10266342,0.0489334015 2.15121679,0.0489334015 Z",
    id: "path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCDD-Pages-New",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pricing",
    transform: "translate(-826.000000, -409.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pricing-Card",
    transform: "translate(383.000000, 375.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Standard",
    transform: "translate(320.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pot1",
    transform: "translate(123.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4500778,11 L37,11.3749143 C32.8794412,17.264775 30.2378811,23.1286414 28.5959708,29.5256563 L28.4655347,30.0408751 C27.358868,34.4751055 26.8601263,38.1625899 26.1620205,45.7252274 L25.8794136,48.8051905 C25.8165871,49.4748608 25.7579802,50.0802473 25.6998041,50.6570574 L25.6649199,51 L25,50.9335183 L25.1048505,49.8853344 L25.6553099,43.9771045 C26.3045439,37.2233921 26.8276761,33.7289585 27.948121,29.3636148 C29.5603057,23.0824134 32.1268255,17.3056432 36.0862781,11.5254918 L36.4500778,11 Z",
    id: "Path",
    fill: "#02B596"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-81",
    transform: "translate(38.581502, 8.086107) rotate(30.000000) translate(-38.581502, -8.086107) translate(32.081502, 2.586107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.19871071,5.04870979e-29 C6.68366353,5.04870979e-29 7.70162323,1.91734762 8.19827219,4.43449301 C9.74325362,3.96652616 11.0951129,3.95967112 11.2582551,4.24414742 C11.4998086,4.66535184 10.2434554,7.05364615 8.16108095,8.63852307 C7.43808244,9.69416911 5.70618932,9.83629677 4.68328428,9.06591973 L4.67679613,9.07541222 C2.22274174,7.53658391 1.04976295,4.69589121 1.38231065,4.24411803 C1.58836393,3.96429727 2.78034986,3.97152726 4.19773066,4.44573502 C4.69409001,1.92350117 5.7129803,5.04870979e-29 6.19871071,5.04870979e-29 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.87218227e-14,7.29631477 C2.46041696,6.89108401 4.55336041,6.91155009 6.19928628,8.89962159 C8.67770496,6.53046387 10.3245318,7.18455192 12.5348263,7.29631477 C11.0768651,8.55309129 9.23817496,10.3168822 6.04975744,10.2686059 C3.24930371,10.1732529 1.49972218,8.57590419 -8.87218227e-14,7.29631477 Z",
    id: "Path-148",
    fill: "#02B596"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-81",
    transform: "translate(8.446200, 13.517734) rotate(-40.000000) translate(-8.446200, -13.517734) translate(1.946200, 8.517734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.19871071,0 C6.68366353,0 7.70162323,1.91734762 8.19827219,4.43449301 C9.74325362,3.96652616 11.0951129,3.95967112 11.2582551,4.24414742 C11.4998086,4.66535184 10.2434554,7.05364615 8.16108095,8.63852307 C7.43808244,9.69416911 5.70618932,9.83629677 4.68328428,9.06591973 L4.67679613,9.07541222 C2.22274174,7.53658391 1.04976295,4.69589121 1.38231065,4.24411803 C1.58836393,3.96429727 2.78034986,3.97152726 4.19773066,4.44573502 C4.69409001,1.92350117 5.7129803,0 6.19871071,0 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.87218227e-14,7.29631477 C2.46041696,6.89108401 4.55336041,6.91155009 6.19928628,8.89962159 C8.67770496,6.53046387 10.3245318,7.18455192 12.5348263,7.29631477 C11.0768651,8.55309129 9.38770381,9.63550433 6.19928628,9.58722809 C3.39883256,9.49187511 1.49972218,8.57590419 -8.87218227e-14,7.29631477 Z",
    id: "Path-148",
    fill: "#02B596"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.4689688,17 C15.2031091,22.054347 18.3572303,27.4406276 20.4500966,33.6135898 L20.634447,34.1659242 C22.0820858,38.5736652 22.8891558,42.7641972 23.8756893,49.9932199 L24,50.9129087 L23.3606885,51 L23.1758772,49.6392323 C22.1811992,42.4241213 21.3570106,38.2995007 19.8396753,33.8240818 C17.830309,27.8974049 14.8320341,22.7115969 10.3653877,17.8409954 L10,17.4467641 L10.4689688,17 Z",
    id: "Path",
    fill: "#02B596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,54 C22.9017832,42.7972679 15.2351166,38.83499 3,42.1131664 C12.1603921,45.1507947 19.0764089,49.1130726 23.7480505,54 L26,54 Z",
    id: "Path-151",
    fill: "#02D3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,53 C43.922968,42.3018648 37.2563013,37.7349848 27,39.29936 C33.2291848,44.29497 39.1503343,48.86185 44.7634487,53 L47,53 Z",
    id: "Path-151",
    fill: "#02B596",
    transform: "translate(37.000000, 46.000000) scale(-1, 1) translate(-37.000000, -46.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9325145,51.3055256 C36.6730407,43.3562176 31.4747878,37.8994091 23.3377557,34.9351002 C28.5393881,42.7676473 33.1929442,48.2236748 37.2984239,51.3031828 L38.9325145,51.3055256 Z",
    id: "Path-151",
    fill: "#02D3AF",
    transform: "translate(31.135135, 43.120313) scale(-1, 1) rotate(10.000000) translate(-31.135135, -43.120313) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9848333,53 C22.5304835,48.4674745 21.0838319,42.1367693 20,36 C25.3576696,38.3237887 27.0785872,47.5817279 25.3576696,53 L23.9848333,53 Z",
    id: "Path-114",
    fill: "#02B596"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-82",
    transform: "translate(14.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    fill: "#7367F0",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.24324324,-1.30120482 L5.83783784,-1.30120482 C0.210438117,19.5180723 17.15096,33.8313253 5.83783784,54.6506024 L-3.24324324,54.6506024 L-3.24324324,-1.30120482 Z",
    id: "Rectangle",
    fill: "#968BFF",
    mask: "url(#mask-3)"
  })))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPot2);
export default __webpack_public_path__ + "static/media/Pot2.4c202bd947a588c94df140fcfd65840d.svg";
export { ForwardRef as ReactComponent };